import { render, staticRenderFns } from "./ConfigPanel.vue?vue&type=template&id=51b87700"
import script from "./ConfigPanel.vue?vue&type=script&lang=js"
export * from "./ConfigPanel.vue?vue&type=script&lang=js"
import style0 from "./ConfigPanel.vue?vue&type=style&index=0&id=51b87700&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports